import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import {
    FormGroup,
    FormBuilder,
    Validators,
    FormControl
} from "@angular/forms";
import {
    AppService,
    APP_DATE_FORMATS,
    AppDateAdapter
} from "../../../../services/app.service";
import { MasterService } from "../../../../services/master.service";
import { MAT_DATE_FORMATS, DateAdapter } from "@angular/material";
import { DistributorService } from "../../../../services/distributor.service";


@Component({
    selector: "app-delivery-detail",
    templateUrl: "./delivery-detail.component.html",
    styleUrls: ["./delivery-detail.component.scss"],
    providers: [
        {
            provide: DateAdapter,
            useClass: AppDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: APP_DATE_FORMATS
        }
    ]
})
export class DeliveryDetailComponent implements OnInit {
    @Input() parent: any;

//distributorList: any = [];

formGroup: FormGroup;
formGroupErrors: any;

distributorList = [];
translations: any;
constructor(
    private formBuilder: FormBuilder,
    public appService: AppService,
    private masterService : MasterService,
    private distributorService : DistributorService
) {

    this.appService.showLoading();
    this.setPageTranslations();
    this.formGroupErrors = {
        D_DistributorId: {},
        D_DeliveryWeek: {},
        D_ShipDate: {},
        D_SheepWeek: {},
        D_LicensePlate: {},
        D_T2No: {},
        D_ReceiveDate: {},
        D_ReceiveWeek: {},
        D_Remark: {},
        D_PlannedDate: {},
        D_ActualDate: {},
        D_ActualWeek: {}
    };

}
scrollItem(item) {
    console.log(item);
}

ngOnInit() {
    this.loadFormGroup();
    this.bindDistributor();


}
bindDistributor(): void {
    this.distributorService
    .list(this.parent.order.D_DistributorId,this.parent.order.C_PostalCodeId,' ','0')
    .subscribe(
    res => this.bindDistributorSuccess(res),
    error => this.apiFaillure(error)
    );
}
bindDistributorSuccess(res): void {
    this.appService.hideLoading();
    if (res.Data != null) {
    this.distributorList = JSON.parse(res.Data);
    if (
    typeof this.parent.order.D_DistributorId == "undefined" ||
    this.parent.order.D_DistributorId <= 0
    ) {
    for (let i = 0; i < this.distributorList.length; i++) {
    if (this.distributorList[i]["Default"]) {
    this.parent.order.D_DistributorId = this.distributorList[i][
    "Id"
    ];
    return;
}
}

if (
    typeof this.parent.order.D_DistributorId == "undefined" ||
    this.parent.order.D_DistributorId <= 0
) {
    this.parent.order.D_DistributorId = this.distributorList[0][
        "Id"
    ];
}
}
} else {
    this.apiFaillure(res.Message);
}
}
setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
}

apiFaillure(error): void {
    this.appService.showDialogue(
    this.translations.hdError,
    this.translations[error]
    );
}

loadFormGroup() {
    if (this.parent.order.Status == 152) {
        this.formGroup = this.formBuilder.group({
            D_DistributorId: ["", Validators.required],
            D_DeliveryWeek: [
                "",
                [Validators.required, Validators.min(1), Validators.max(53)]
            ],
            D_ShipDate: ["", Validators.required],
            D_SheepWeek: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_LicensePlate: ["-", Validators.required],
            D_T2No: ["-", Validators.required],
            D_ReceiveDate: ["", Validators.required],
            D_ReceiveWeek: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_Remark: [],
            D_PlannedDate: [{
                    value: "",
                    disabled: true
                }, Validators.required],
            D_ActualDate: [{
                    value: "",
                    disabled: true
                }, Validators.required],
            D_ActualWeek: [
                {
                    value: "",
                    disabled: true
                }
            ]
        });
    } else {
        this.formGroup = this.formBuilder.group({
            D_DistributorId: ["", Validators.required],
            D_DeliveryWeek: [
                "",
                [Validators.required, Validators.min(1), Validators.max(53)]
            ],
            D_ShipDate: [],
            D_SheepWeek: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_LicensePlate: ["-"],
            D_T2No: ["-"],
            D_ReceiveDate: [],
            D_ReceiveWeek: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_Remark: [],
            D_PlannedDate: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_ActualDate: [
                {
                    value: "",
                    disabled: true
                }
            ],
            D_ActualWeek: [
                {
                    value: "",
                    disabled: true
                }
            ]
        });
    }

    this.formGroup.valueChanges.subscribe(() => {
        this.formGroupErrors = this.appService.onFormValuesChanged(
            this.formGroup,
            this.formGroupErrors
        );
        this.appService.setFormValid(this.formGroup.invalid);
    });
}
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/delivery-detail/delivery-detail.component.ts